export const onDone = contact => ({
  widget: 'contacts',
  type: 'onDone',
  payload: { contact },
})



// WEBPACK FOOTER //
// ./src/contacts/actions/onDone.js